import { render, staticRenderFns } from "./BUploadFileV3.vue?vue&type=template&id=643e33b4&"
import script from "./BUploadFileV3.vue?vue&type=script&lang=js&"
export * from "./BUploadFileV3.vue?vue&type=script&lang=js&"
import style0 from "./BUploadFileV3.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports